
import { ApiCaller } from '@frontend/api'
import type { Rating } from '@types'
import { useChatContext } from '@ui/chat/ChatProvider'
import FeedbackModal from '@ui/chat/components/FeedbackModal'
import { useMessageContext } from '@ui/chat/modules/Message'
import { StarRating } from '@ui/components'
import { useEffect, useState } from 'react'

function MessageFooter() {
	const { message } = useMessageContext()
	const [openFeedback, setOpenFeedback] = useState(false)
	const [selectedRatingNote, setSelectedRatingNote] = useState(0)
	const [feedbackMessageId, setFeedbackMessageId] = useState<string | undefined>()
	const [rating, setRating] = useState<Rating>()
	const { chatDispatch } = useChatContext()
	const options = useChatContext()

	useEffect(() => {
		if (rating && message.id) {
			chatDispatch({ type: 'updateMessage', message: { id: message.id, rating } })
		}
	}, [rating])

	function handleRating(rating: number) {
		ApiCaller.track('Feedback_Open')
		setOpenFeedback(true)
		setSelectedRatingNote(rating)
	}

	return (
		<>
			{ !rating && message.status === 'processed'
				&& message.role === 'assistant' && !message.rating && options.type === 'chat'
				&& <div className='text-center text-gray-400 text-sm pb-4 pt-1'>
					<p>Give feedback on this answer to the VirtualBrain team</p>
					<StarRating
						setId={ setFeedbackMessageId }
						id={ message.id }
						onRating={ handleRating } />
				</div> }
			{ openFeedback && feedbackMessageId
				? <FeedbackModal
					isOpen={ openFeedback }
					selectedRatingNote={ selectedRatingNote }
					setSelectedRatingNote={ setSelectedRatingNote }
					type='message'
					id={ feedbackMessageId }
					setRating={ setRating }
					onClose={ () => {
						setOpenFeedback(false)
					} }
				/>
				: null }
		</>
	)
}

export default MessageFooter
